module.exports = __webpack_public_path__ + "img/Logo_about.e7d954dd.png";